import React, { useState, useEffect } from "react"
import { Col, Container, Row, Table } from "react-bootstrap"
import { GetCollection } from "../../../firebase/firebase"

export const SurveyDataWrapper = () => {
    const [responses, setResponses] = useState([])
    const [columns, setColumns] = useState([])

    const sort = (array, attribute) => {
        return array.sort(function (x, y) { return x == attribute ? -1 : y == attribute ? 1 : 0; });
    }
    useEffect(() => {
        GetCollection('surveys', false).then((data) => {
            setResponses(data.docs.map(doc => doc.data()))

        })

    }, [])

    useEffect(() => {

        if (responses.length != 0) {
            let tempCols = []
            responses.map(response =>
                tempCols.push(Object.keys(response)))
            tempCols = tempCols.flat()
            const tempSet = new Set(tempCols)
            tempCols = Array.from(tempSet)
            tempCols = sort(tempCols, 'race')
            tempCols = sort(tempCols, 'sex')
            tempCols = sort(tempCols, 'weight')
            tempCols = sort(tempCols, 'height')
            tempCols = sort(tempCols, 'age')
            tempCols = sort(tempCols, 'id')
            setColumns(tempCols)
        }
    }, [responses])



    return (
        <>

            <Container fluid>
                <Row>
                    <Col lg={2}>
                        <Row>
                            <h4>{responses.length} Responses </h4>
                        </Row>
                        <Row>
                            <div>
                                <h4>Column Headers</h4>
                            </div>
                            {columns && columns.map((column, i) => {

                                return (
                                    <div key={i + 'ffffff'}>
                                        {column}
                                    </div>

                                )


                            })}
                        </Row>
                    </Col>
                    <Col lg={10}>
                        <Table striped bordered responsive>
                            <thead>
                                <tr>
                                    {columns && columns.map((column, i) => {
                                        return (
                                            <th key={'colHeader' + i}>
                                                {column}
                                            </th>
                                        )
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {responses && responses.map((response, i) => {
                                    return (
                                        <tr key={i + 'rows'}>
                                            {Object.values(columns) && Object.values(columns).map((column, i) => {
                                                return (
                                                    <td key={i + 'data'}>

                                                        {response[column] ? response[column].toString() : false.toString()}

                                                    </td>

                                                )
                                            })}
                                        </tr>

                                    )
                                })}
                            </tbody>


                        </Table>
                    </Col>
                </Row>
            </Container>
        </>

    )
}

const ColumnsRow = (props) => {
    const columns = props.columns
    return (
        <>
            <Row>
                {columns && columns.map((column, i) => {
                    return (
                        <Col>
                            {column}
                        </Col>
                    )
                })}

            </Row>
        </>
    )
}

const ResponseRow = (props) => {
    const response = props.response
    return (
        <>
            <Row>
                <Col>
                    {response.age}
                </Col>
            </Row>
        </>
    )
}